//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: "vipdescription"
}



// WEBPACK FOOTER //
// ./src/components/vipdescription/vipdescription.vue